module.exports = __webpack_public_path__ + "merge_right.svg?1053f907482e1792894617b5ba036a82";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/merge_right.svg
// module id = 178
// module chunks = 0